import React from 'react';
import { BodyText, DataGrid, IFilteredDataGridColumnProps } from 'ui-toolkit';
import { IFeatureIdentityData } from '../../../types/administration/features/IFeature';
import { FeatureIdentitiesMenuDropdown } from './subComponents/FeatureUserMenuDropdown';

export interface IFeatureIdentitiesTableProps {
  featureIdentityData: IFeatureIdentityData[];
  isLoading: boolean;
}

const columns: IFilteredDataGridColumnProps<IFeatureIdentityData>[] = [
  {
    dataField: 'name',
    headerStyle: { width: '120px' },
    text: 'Name',
  },
  {
    dataField: 'description',
    headerStyle: { width: '100px' },
    text: 'Description',
  },
  {
    dataField: 'identityName',
    headerStyle: { width: '100px' },
    text: 'Full Name',
  },
  {
    dataField: 'identityEmail',
    headerStyle: { width: '100px' },
    text: 'Email',
  },
  {
    dataField: 'isOn',
    headerStyle: { width: '100px' },
    formatter: (column, row) => {
      return <BodyText>{row.isOn ? 'Active' : 'Deactivated'}</BodyText>;
    },
    text: 'Is On',
  },
  {
    dataField: 'feature.menu',
    headerStyle: { width: '48px' },
    formatter: (column, row) => {
      return <FeatureIdentitiesMenuDropdown feature={row} />;
    },
    text: '',
  },
];

export const FeatureIdentitiesTable: React.FC<IFeatureIdentitiesTableProps> = ({ featureIdentityData, isLoading }) => {
  return <DataGrid columns={columns} data={featureIdentityData} keyField="compositeKey" loading={isLoading} remote />;
};
